// JobDetailsState.ts
import { Job } from '../../../company/JobManagement/model/JobModel';

export interface ToastMessage {
  id: number;
  message: string;
  type: 'success' | 'error' | 'info' | 'warning';
}

export interface JobDetailsState {
  job: Job | null;
  loading: boolean;
  error: string | null;
  applying: boolean;
  toasts: ToastMessage[];
}

export type JobDetailsAction =
  | { type: 'FETCH_START' }
  | { type: 'FETCH_SUCCESS'; payload: Job }
  | { type: 'FETCH_ERROR'; payload: string }
  | { type: 'APPLY_START' }
  | { type: 'APPLY_SUCCESS'; payload: Job }
  | { type: 'APPLY_ERROR'; payload: string }
  | { type: 'CLEAR_ERROR' }
  | { type: 'ADD_TOAST'; payload: { message: string; type: 'success' | 'error' | 'info' | 'warning' } }
  | { type: 'REMOVE_TOAST'; payload: number }
  | { type: 'CLEAR_TOASTS' };

export const initialJobDetailsState: JobDetailsState = {
  job: null,
  loading: true,
  error: null,
  applying: false,
  toasts: [],
};

export const jobDetailsReducer = (
  state: JobDetailsState,
  action: JobDetailsAction
): JobDetailsState => {
  switch (action.type) {
    case 'FETCH_START':
      return { ...state, loading: true, error: null };

    case 'FETCH_SUCCESS':
      return { ...state, job: action.payload, loading: false, error: null };

    case 'FETCH_ERROR':
      return { ...state, loading: false, error: action.payload };

    case 'APPLY_START':
      return { ...state, applying: true };

    case 'APPLY_SUCCESS':
      return { ...state, job: action.payload, applying: false };

    case 'APPLY_ERROR':
      return { ...state, applying: false, error: action.payload };

    case 'CLEAR_ERROR':
      return { ...state, error: null };

    case 'ADD_TOAST':
      const newToast = {
        id: Date.now(),
        message: action.payload.message,
        type: action.payload.type,
      };
      return { ...state, toasts: [...state.toasts, newToast] };

    case 'REMOVE_TOAST':
      return { ...state, toasts: state.toasts.filter(toast => toast.id !== action.payload) };

    case 'CLEAR_TOASTS':
      return { ...state, toasts: [] };

    default:
      return state;
  }
};